import { render, staticRenderFns } from "./TempSignature.vue?vue&type=template&id=d20d53fe&scoped=true"
import script from "./TempSignature.vue?vue&type=script&lang=js"
export * from "./TempSignature.vue?vue&type=script&lang=js"
import style0 from "./TempSignature.vue?vue&type=style&index=0&id=d20d53fe&prod&lang=css"
import style1 from "./TempSignature.vue?vue&type=style&index=1&id=d20d53fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20d53fe",
  null
  
)

export default component.exports